import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, Output, QueryList, ViewChildren } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { Router } from '@angular/router'
import { BoundingBox, TextSearchDestination, TextSearchListing } from '../../../../../graphql'
import { ListingSearchService } from '../../../../injectable/listing-search-service'
import { UnsubscribeOnDestroy } from '../../../../utility'

@Component({
    selector: 'app-search-text',
    templateUrl: 'search-text.html',
})
export class SearchTextComponent extends UnsubscribeOnDestroy implements AfterViewInit {
    @Input() inline = false
    @Input() collapsableSearchInput = true
    @Input() columnLayout = false

    loading = false
    propertiesFiltered: TextSearchListing[] = []
    destinationsFiltered: TextSearchDestination[] = []
    searchTerm = ''
    showSearchInput = false
    formGroup: FormGroup

    @Output() locationSelectedEvent = new EventEmitter<BoundingBox>()

    @ViewChildren('searchTextInput') searchTextInput: QueryList<ElementRef>

    @HostListener('document:keydown.escape', ['$event'])
    handleKeyboardEvent() {
        this.showSearchInput = false
    }

    @HostListener('document:click', ['$event'])
    clickout(event: Event) {
        const targetElement = event.target as HTMLInputElement

        if (!this.eRef.nativeElement.contains(targetElement)) {
            this.showSearchInput = false
        }
    }

    constructor(
        private eRef: ElementRef<HTMLElement>,
        private listingSearchService: ListingSearchService,
        private _router: Router,
    ) {
        super()

        this.formGroup = new FormGroup({
            searchTextValue: new FormControl()
        })

        this.formGroup.valueChanges.subscribe(value => {
            this.searchTerm = value.searchTextValue.toLowerCase()
            this.filterResultsBySearchTerm()
        })
    }

    ngAfterViewInit(): void {
        this.searchTextInput.changes.subscribe(() => {
            const input = this.searchTextInput?.first

            if (input?.nativeElement) {
                input.nativeElement.focus()
            }
        })
    }

    activateSearchInput() {
        this.showSearchInput = true
    }

    clearSearchText() {
        this.formGroup.controls.searchTextValue.setValue('')
    }

    boldMatchCharacters(sentence: string) {
        const regEx = new RegExp(this.searchTerm, 'gi')
        return sentence.replace(regEx, '<strong>$&</strong>')
    }

    async locationSelected($event: {name: string, boundingBox: BoundingBox}) {
        const { swLat, swLng, neLat, neLng } = $event.boundingBox
        const boundingBoxString = JSON.stringify({ swLat, swLng, neLat, neLng })

        // If searching from route other than search-listings reroute.
        if (this._router.url.indexOf('/search-listings') === -1) {
            await this._router.navigateByUrl(`/search-listings?boundingBox=${boundingBoxString}`)
        } else {
            this.locationSelectedEvent.next($event.boundingBox)
        }
    }

    openListing(listingId: string) {
        const url = this._router.serializeUrl(this._router.createUrlTree(['/listing', listingId]))
        window.open(url, '_blank')
    }

    private filterResultsBySearchTerm() {
        const { properties, destinations } = this.listingSearchService.filterListings(this.searchTerm)
        this.propertiesFiltered = properties
        this.destinationsFiltered = destinations
    }
}
